export default import.meta.ROLLDOWN_FILE_URL_ew2xj1m8yAIpPRH3jxr$Zw